export enum ActivePage {
  Narration = 0,
  Statistics = 1,
  PlayerStats = 2,
  Match = 3,
  Lineup = 4,
  Standings = 5,
  XgMap = 6,
  PassMap = 7,
  HeatMap = 8,
  Chalkboard = 9,
}

export const tabToPage = (t?: string): ActivePage | undefined => {
  switch ((t || "").toLowerCase()) {
    case "narration":
      return ActivePage.Narration;
    case "statistics":
      return ActivePage.Statistics;
    case "playerstats":
    case "player-stats":
    case "player_stats":
      return ActivePage.PlayerStats;
    case "match":
      return ActivePage.Match;
    case "lineup":
      return ActivePage.Lineup;
    case "standings":
      return ActivePage.Standings;
    case "xgmap":
      return ActivePage.XgMap;
    case "passmap":
    case "pass-map":
      return ActivePage.PassMap;
    case "heatmap":
    case "heat-map":
      return ActivePage.HeatMap;
    case "chalkboard":
      return ActivePage.Chalkboard;
    default:
      return ActivePage.Narration;
  }
};

export const pageToTab = (p: ActivePage): string => {
  switch (p) {
    case ActivePage.Narration:
      return "narration";
    case ActivePage.Statistics:
      return "statistics";
    case ActivePage.PlayerStats:
      return "player-stats";
    case ActivePage.Match:
      return "match";
    case ActivePage.Lineup:
      return "lineup";
    case ActivePage.Standings:
      return "standings";
    case ActivePage.XgMap:
      return "xgmap";
    case ActivePage.PassMap:
      return "pass-map";
    case ActivePage.HeatMap:
      return "heatmap";
    case ActivePage.Chalkboard:
      return "chalkboard";
    default:
      return "narration";
  }
};
